import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { post } from '../../api';

import IpsDTProjectGrid from '../../components/ProjectsGrid/IpsDTProjectGrid';

import IpsDTProjectList from 'components/ProjectsList/IpsDTProjectList';
import IPSDTViewType from 'components/ViewType/IPSDTViewType';
import { directToProject } from '../../utils/Dashboard';

export default withRouter(function DataTrackerComplete(props) {
  const { context, history, cardview, onViewTypeChange, projectList } = props;

  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getProjects() {
      if (projects && projects.length < 1) {
        spinnerOn();
        setIsLoading(true);

        const result = await post(`ipsprojects/complete`, '', {});

        setProjects(result.data);

        spinnerOff();
        setIsLoading(false);
      }
    }

    getProjects();
  }, []);

  function goToProject(project) {
    

    directToProject(project,history,'datatracker_complete',context)
  }
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <IPSDTViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'DT_C'}
          dtstatus={'DT_C'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsDTProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={goToProject}
          isLoading={isLoading}
          {...props}
        />
      ) : (
        <IpsDTProjectList
          projects={projectList(projects)}
          onButtonClick={goToProject}
          {...props}
        />
      )}
      {}
    </Fragment>
  );
});
